<template>
  <div class="AtlasShare">
    <div class="AtlasShare-icons">
      <a
        class="AtlasShare-link"
        :href="fbShare"
        @click.prevent="launch(fbShare)"
      >
        <atlas-icon
          class="AtlasShare-icon AtlasShare-icon--facebook"
          name="facebook"
          :size="22"
        />
      </a>

      <a
        class="AtlasShare-link"
        :href="twShare"
        @click.prevent="launch(twShare)"
      >
        <atlas-icon
          class="AtlasShare-icon AtlasShare-icon--twitter"
          name="twitter"
          :size="22"
        />
      </a>

      <a class="AtlasShare-link" :href="mailto">
        <atlas-icon
          class="AtlasShare-icon AtlasShare-icon--email"
          name="email"
          :size="22"
        />
      </a>
    </div>
  </div>
</template>

<script>
const SHARE_WINDOW_SETTINGS = [
  'menubar=no',
  'toolbar=no',
  'resizable=yes',
  'scrollbars=yes',
  'height=300',
  'width=600',
].join();

export default {
  data: () => ({
    // NOTE: this url isn't reactive, it assumes the url to share is the same
    // as it was when this component was created (i.e. when the dropdown opened)
    shareUrl: escape(window.location.href),
  }),

  computed: {
    mailto() {
      return `mailto:?subject=Data Atlas&body=${this.shareUrl}`;
    },

    fbShare() {
      // return `https://www.facebook.com/sharer/sharer.php?u=${u}&t=${t}`;
      return `https://www.facebook.com/sharer/sharer.php?u=${this.shareUrl}`;
    },

    twShare() {
      // return `https://twitter.com/share?url=${u}&text=${t}`;
      return `https://twitter.com/share?url=${this.shareUrl}`;
    },
  },

  methods: {
    launch(url) {
      this.$store.commit('ui/closeDropdown');
      window.open(url, '', SHARE_WINDOW_SETTINGS);
    },
  },
};
</script>

<style lang="scss">
.AtlasShare {
  &-icons {
    @include clearfix;
  }

  &-link {
    @include size(45px);
    display: block;
    cursor: pointer;
    float: left;

    &:hover {
      background-color: #cfd3d7;
    }
  }

  // Extra specificity to override .Indicator a
  .AtlasShare-link {
    color: inherit;
  }

  &-icon {
    position: relative;

    &--facebook {
      top: 11px;
      left: 18px;
    }

    &--twitter {
      top: 12px;
      left: 14px;
    }

    &--email {
      top: 14px;
      left: 13px;
    }
  }
}
</style>
